import { Injectable } from '@angular/core'
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  UrlTree,
} from '@angular/router'
import { Observable } from 'rxjs'

import { AuthenticationService } from '../_services/authentication.service'

@Injectable({ providedIn: 'root' })
/**
 * @declaration Authentication guard class
 *
 */
export class AuthGuard implements CanActivate, CanActivateChild {
  isLoggedIn: boolean = false
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationService.isLoggedIn$()
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationService.isLoggedIn$()
  }
}
